import { useMutation } from '@tanstack/react-query';

import { postUserOtpDelete } from '../requests';

export const usePostUserOtpDelete = () =>
  useMutation({
    mutationFn: postUserOtpDelete,
  });
